import { render, staticRenderFns } from "./BaseFieldset.vue?vue&type=template&id=06b1b6ee&functional=true&"
import script from "./BaseFieldset.vue?vue&type=script&lang=js&"
export * from "./BaseFieldset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports